import Map from '../Map/Map';
import InvestProRegions from '../Layers/InvestProLayers/InvestProRegions.jsx';
import InvestProDistricts from '../Layers/InvestProLayers/InvestProDistricts.jsx';
import InvestProDotsLayer from '../Layers/InvestProLayers/InvestProDotsLayer.jsx';
import TopFilters from '../TopFilters/TopFilters.jsx';
import ProjectsTree from '../ProjectsTree/ProjectsTree.jsx';
import RegionsTree from '../RegionsTree/RegionsTree.jsx';
import ProjectModal from '../ProjectModal/ProjectModal.jsx';
import MapGradient from '../MapGradient/MapGradient.jsx';
import MapNavControls from '../MapNavControls/MapNavControls.jsx';
import InvestProjectsLayerManager from '../Layers/InvestProjectsLayerManager.jsx';
import FerryTerminalsLayer from '../Layers/InvestProLayers/FerryTerminalsLayer.jsx';
import AltaRailwayLayer from '../Layers/InvestProLayers/AltaRailwayLayer.jsx';
import KzAirportsLayer from '../Layers/InvestProLayers/KzAirportsLayer.jsx';
import MinresLayer from '../Layers/InvestProLayers/MinresLayer.jsx';
import Sezlayer from '../Layers/InvestProLayers/SezLayer.jsx';
import IzDotsLayer from '../Layers/InvestProLayers/IzDotsLayer.jsx';
import HexagonsLayer from '../Layers/InvestProLayers/HexagonsLayer.jsx';
import HeatmapSelector from '../HeatmapSelector/HeatmapSelector.jsx';
import KazakhstanLayer from '../Layers/InvestProLayers/KazakhstanLayer.jsx';
import KzHelicopterLayer from '../Layers/InvestProLayers/KzHelicopterLayer.jsx';
import DotPopup from '../MapPopups/DotPopup/DotPopup.jsx';
import AzsLayer from '../Layers/InvestProLayers/AzsLayer.jsx';
import StoLayer from '../Layers/InvestProLayers/StoLayer.jsx';
import WarehouseLayer from '../Layers/InvestProLayers/WarehouseLayer.jsx';

function MapBlock() {
  const widgets = (
    <>
      <InvestProRegions />;
      <InvestProDistricts />
      <AltaRailwayLayer />
      <KzAirportsLayer />
      <KzHelicopterLayer />
      <FerryTerminalsLayer />
      <MinresLayer />
      <AzsLayer />
      <StoLayer />
      <WarehouseLayer />
      <Sezlayer />
      <IzDotsLayer />
      <InvestProjectsLayerManager />
      <HexagonsLayer />
      <KazakhstanLayer />
      <TopFilters />
      <ProjectsTree />
      <RegionsTree />
      <HeatmapSelector />
      <ProjectModal />
      <MapGradient />
      <DotPopup />
      <div
        style={{
          position: 'absolute',
          right: 20,
          top: '50%',
          transform: 'translateY(-50%)',
        }}
      >
        <MapNavControls />
      </div>
    </>
  );

  return (
    <>
      <Map />
      {widgets}
    </>
  );
}

export default MapBlock;
